/* Purenza product page magnifier — Al-Fatah style (Nov 2026)
   Desktop: hovering a product image shows a small lens box on the
   image and a large zoom pane beside the gallery with that part
   enlarged; the pane follows the lens. Touch devices keep the theme's
   normal gallery behavior (activation requires real mouse movement,
   and any touch hides it).
   Event delegation on the document, so slider clones and variant
   slide changes work. If the theme's own magnify (image-magnify-hover)
   is ever enabled, this script steps aside to avoid double behavior. */
(function () {
  if (!window.location.pathname.includes('/products/')) return;
  if (document.querySelector('img.image-magnify-hover')) return;

  var LENS_W_FRAC = 0.25; // lens width as a fraction of the image width
  var LENS_H_FRAC = 0.35; // lens height as a fraction of the image height
  var PANE_GAP = 18; // px between gallery and zoom pane
  var MIN_WIDTH = 750; // below this the layout is single-column; no pane

  var active = null; // { container, img, lens, pane, host, painted, ... }
  var pending = null; // { container, x, y } waiting for real mouse movement

  function largestSrc(img) {
    var best = null;
    var bestW = 0;
    if (img.srcset) {
      img.srcset.split(',').forEach(function (part) {
        var m = part.trim().match(/^(\S+)\s+(\d+)w$/);
        if (m && parseInt(m[2], 10) > bestW) {
          bestW = parseInt(m[2], 10);
          best = m[1];
        }
      });
    }
    return best || img.currentSrc || img.src;
  }

  // The rectangle the picture actually paints inside the <img> box,
  // accounting for object-fit (this theme uses contain for media).
  function paintedRect(img) {
    var r = img.getBoundingClientRect();
    if (!img.naturalWidth || !img.naturalHeight) {
      return { left: r.left, top: r.top, width: r.width, height: r.height };
    }
    var fit = window.getComputedStyle(img).objectFit;
    var s =
      fit === 'cover'
        ? Math.max(r.width / img.naturalWidth, r.height / img.naturalHeight)
        : Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
    var w = img.naturalWidth * s;
    var h = img.naturalHeight * s;
    return {
      left: r.left + (r.width - w) / 2,
      top: r.top + (r.height - h) / 2,
      width: w,
      height: h,
    };
  }

  function ensureNodes(container) {
    var host = container.closest('.product__media-wrapper') || container.parentElement;
    host.classList.add('pz-pane-host');

    var lens = container.querySelector('.pz-lens');
    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'pz-lens';
      lens.setAttribute('aria-hidden', 'true');
      container.appendChild(lens);
    }
    var pane = host.querySelector('.pz-pane');
    if (!pane) {
      pane = document.createElement('div');
      pane.className = 'pz-pane';
      pane.setAttribute('aria-hidden', 'true');
      host.appendChild(pane);
    }
    return { host: host, lens: lens, pane: pane };
  }

  function show(container, img, event) {
    var nodes = ensureNodes(container);
    active = {
      container: container,
      img: img,
      lens: nodes.lens,
      pane: nodes.pane,
      host: nodes.host,
    };

    var p = paintedRect(img);
    active.painted = p;

    var lensW = Math.max(60, p.width * LENS_W_FRAC);
    var lensH = Math.max(60, p.height * LENS_H_FRAC);
    active.lensW = lensW;
    active.lensH = lensH;
    active.lens.style.width = lensW + 'px';
    active.lens.style.height = lensH + 'px';

    // Pane beside the gallery, same height as the gallery (Al-Fatah style).
    var hostRect = active.host.getBoundingClientRect();
    var list = container.closest('.product__media-list') || container;
    var listRect = list.getBoundingClientRect();
    var paneH = listRect.height;
    var paneW = Math.min(560, Math.max(300, paneH * 0.92));
    active.paneW = paneW;
    active.paneH = paneH;
    active.pane.style.width = paneW + 'px';
    active.pane.style.height = paneH + 'px';
    active.pane.style.left = listRect.right - hostRect.left + PANE_GAP + 'px';
    active.pane.style.top = listRect.top - hostRect.top + 'px';

    active.scaleX = paneW / lensW;
    active.scaleY = paneH / lensH;
    active.pane.style.backgroundImage = "url('" + largestSrc(img) + "')";
    active.pane.style.backgroundSize =
      p.width * active.scaleX + 'px ' + p.height * active.scaleY + 'px';

    active.lens.classList.add('pz-on');
    active.pane.classList.add('pz-on');
    container.classList.add('pz-zooming');
    move(event);
  }

  function move(event) {
    if (!active) return;
    var p = active.painted;
    var x = event.clientX - p.left;
    var y = event.clientY - p.top;
    var lx = Math.min(Math.max(x - active.lensW / 2, 0), Math.max(p.width - active.lensW, 0));
    var ly = Math.min(Math.max(y - active.lensH / 2, 0), Math.max(p.height - active.lensH, 0));

    var cRect = active.container.getBoundingClientRect();
    active.lens.style.left = p.left - cRect.left + lx + 'px';
    active.lens.style.top = p.top - cRect.top + ly + 'px';
    active.pane.style.backgroundPosition =
      -lx * active.scaleX + 'px ' + -ly * active.scaleY + 'px';
  }

  function hide() {
    pending = null;
    if (!active) return;
    active.lens.classList.remove('pz-on');
    active.pane.classList.remove('pz-on');
    active.container.classList.remove('pz-zooming');
    active = null;
  }

  function findContainer(node) {
    if (!node || !node.closest) return null;
    return node.closest('.product__media-item .product-media-container');
  }

  document.addEventListener('mouseover', function (event) {
    var container = findContainer(event.target);
    if (!container) {
      if (!active) pending = null;
      return;
    }
    if (active && active.container === container) return;
    if (pending && pending.container === container) return;
    if (container.querySelector('video, deferred-media, product-model, iframe')) return;
    pending = { container: container, x: event.clientX, y: event.clientY };
  });

  document.addEventListener('mousemove', function (event) {
    if (pending) {
      var dx = Math.abs(event.clientX - pending.x);
      var dy = Math.abs(event.clientY - pending.y);
      if (dx + dy > 6) {
        var container = pending.container;
        pending = null;
        if (window.innerWidth >= MIN_WIDTH) {
          var img = container.querySelector('img');
          if (img) {
            hide();
            show(container, img, event);
          }
        }
      }
      return;
    }
    if (active) move(event);
  });

  document.addEventListener('mouseout', function (event) {
    if (pending && !pending.container.contains(event.relatedTarget)) pending = null;
    if (active && !active.container.contains(event.relatedTarget)) hide();
  });

  document.addEventListener('touchstart', hide, { passive: true });
  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
})();
